module.exports = __webpack_public_path__ + "static/media/ic_arrow_forward_48px.ba1a97c5.svg";